<template>
  <div>
    <Title :pages="[{ icon: 'file-invoice', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-5">
                <div class="col pt-0">
                  <v-menu
                    ref="desde_selected"
                    v-model="desde_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="desde_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    clearable
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="state_selected != null && (state_selected.id == purchaseOrderService.STATE_PENDING || state_selected.id == purchaseOrderService.STATE_PARTIALLY)"
                        v-model="desde_selected"
                        label="Desde"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="pt-0 mt-0"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="desde_selected_open = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col pt-0">
                  <v-menu
                    ref="hasta_selected"
                    v-model="hasta_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="hasta_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    clearable
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="state_selected != null && (state_selected.id == purchaseOrderService.STATE_PENDING || state_selected.id == purchaseOrderService.STATE_PARTIALLY)"
                        v-model="hasta_selected"
                        label="Hasta"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="pt-0 mt-0"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_selected = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col pt-0">
                  <v-text-field clearable v-model="purchase_order_number_selected" autocomplete="off" class="pt-0 mt-0" label="Nº de Orden"></v-text-field>
                </div>

                <div class="col pt-0">
                  <v-combobox
                    v-model="state_selected"
                    autocomplete="off"
                    data-vv-as="state_selected"
                    name="state_selected"
                    item-text="name"
                    item-value="id"
                    :items="states"
                    label="Estado"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>
              </div>

              <div class="row">
                <div class="col pt-0">
                  <v-combobox
                    v-model="supplier_selected"
                    autocomplete="off"
                    data-vv-as="supplier_selected"
                    name="supplier_selected"
                    item-text="name"
                    item-value="id"
                    :items="suppliers"
                    label="Proveedor"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>
                <div class="col pt-0">
                  <v-combobox
                    v-model="receiver_selected"
                    autocomplete="off"
                    data-vv-as="receiver_selected"
                    name="receiver_selected"
                    item-text="name"
                    item-value="id"
                    :items="receivers"
                    label="Receptor"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col pt-0" v-if="isProductCompany()">
                  <v-combobox
                    v-model="product_selected"
                    autocomplete="off"
                    data-vv-as="product_selected"
                    name="product_selected"
                    item-text="name"
                    item-value="id"
                    :items="products"
                    label="Producto"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col pt-0" style="display: flex; justify-content: end">
                  <v-btn color="info" class="" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <v-btn color="blue-grey" class="mt-3" small dark :loading="dialog_export" @click="exportToExcel"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>

          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{
            descending: true,
            itemsPerPage: 15,
          }"
          @pagination="updatePagination"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.cbte_fch }}</td>
              <td>{{ props.item.estimated_delvery_date }}</td>
              <td>{{ props.item.purchase_order_number != null ? props.item.purchase_order_number.toString().padStart(8, "0") : "-" }}</td>
              <td>{{ props.item.external_reference != null ? props.item.external_reference : "-" }}</td>
              <td>{{ props.item.state.name }}</td>
              <td>{{ props.item.supplier_name }}</td>
              <td>{{ props.item.receiver_name }}</td>
              <td>{{ props.item.product_name }}</td>
              <td class="text-center">{{ props.item.discount_per }}%</td>
              <td class="text-center">{{ formatUtils.formatPrice(props.item.price) }}</td>
              <td class="text-center">{{ props.item.quantity }}</td>
              <td class="text-center">{{ props.item.quantity_received }}</td>
              <td class="text-center">{{ props.item.quantity_remaining }}</td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { purchaseOrderService } from "@/libs/ws/purchaseOrderService";
import { reportService } from "@/libs/ws/reportService";
import { emmiterService } from "@/libs/ws/emmiterService";
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import SettingsMixin from "@/mixins/SettingsMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";

export default {
  components: { Title },
  mixins: [GenericMixin, RolMixin, SettingsMixin, ExportMixin],
  data() {
    return {
      voucherForRemito: null,
      formatUtils: formatUtils,
      purchaseOrderService: purchaseOrderService,
      service: reportService,
      page_title: "Reporte Ordenes de Compra",
      modal_title: "Reporte Orden de Compra",
      headers: [
        { text: "Fecha", align: "left", sortable: true, value: "cbte_fch" },
        { text: "Fecha entrega", align: "left", sortable: true, value: "estimated_delvery_date" },
        { text: "Nº Orden", align: "left", sortable: true, value: "purchase_order_number" },
        { text: "Referencia externa", align: "left", sortable: true, value: "external_reference" },

        { text: "Estado", align: "left", sortable: true, value: "state" },
        { text: "Proveedor", align: "left", sortable: true, value: "supplier_name" },
        { text: "Receptor", align: "left", sortable: true, value: "receiver_name" },
        { text: "Producto", align: "left", sortable: true, value: "product_name" },
        { text: "Bonif.", align: "left", sortable: true, value: "discount_per" },
        { text: "Precio unitario", align: "left", sortable: true, value: "price" },
        { text: "Cant. solicitada", align: "center", sortable: true, value: "quantity" },
        { text: "Cant. recibida", align: "center", sortable: true, value: "quantity_received" },
        { text: "Cant. pendiente", align: "center", sortable: true, value: "quantity_remaining" },
      ],
      list: [],
      states: [],
      suppliers: [],
      receivers: [],
      clients: [],
      products: [],
      costs_centers: [],
      desde_selected_open: false,
      hasta_selected_open: false,
      purchase_order_number_selected: null,
      sub_cost_center_selected: null,
      supplier_selected: null,
      receiver_selected: null,
      product_selected: null,
      state_selected: null,
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
    };
  },
  mounted() {
    this.loadComboData();
    this.loadList(this.service, this.getFilterParams());
  },
  methods: {
    loadList(service, param = null) {
      this.loading = true;

      if (param == null) {
        param = this.getFilterParams();
      }

      this.open_filter = false;
      service
        .getReportsPurchaseOrder(param)
        .then((response) => {
          console.log("response", response);
          this.list = response.result;
          this.loading = false;

          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }
        })
        .catch((e) => {
          console.log("service.getReportsSaleOrder error");
          console.log(e);
          this.loading = false;
        });
    },
    getFilterParams() {
      const param = {
        from: this.desde_selected,
        to: this.hasta_selected,
        supplier: this.supplier_selected != null ? this.supplier_selected.id : null,
        receiver: this.receiver_selected != null ? this.receiver_selected.id : null,
        product: this.product_selected != null ? this.product_selected.id : null,
        sub_cost_center: this.sub_cost_center_selected != null ? this.sub_cost_center_selected.id : null,
        state: this.state_selected != null ? this.state_selected.id : null,
        purchase_order_number: this.purchase_order_number_selected,
      };
      return param;
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    loadComboData() {
      generalService.setSection(Constant.SECTION_SUPPLIERS);
      generalService
        .filter()
        .then((response) => {
          this.suppliers = response.result;
        })
        .catch((e) => {
          console.log("suppliers.filter error");
          console.log(e);
        });

      emmiterService.filter({}).then((response) => {
        this.receivers = response.result;
      });

      generalService.filter({}, Constant.SECTION_PRODUCTS).then((response) => {
        this.products = response.result;
      });

      purchaseOrderService.list_states().then((response) => {
        this.states = response.result;
      });
    },
    exportToExcel() {
      var param = this.getFilterParams();
      param["export"] = true;

      let fileName = "Reporte-Orden-Compra.xlsx";

      this.exportExcel(Constant.SECTION_REPORTS + "/purchase-order", param, fileName);
    },
  },
};
</script>
